// extracted by mini-css-extract-plugin
export var statItem = "_lr-1";
export var statsRow = "_lr-0";